import RestaurantClosedModal from './RestaurantClosedModal';

export default {
  RestaurantClosedModal,
};
